if (!customElements.get('fan-collection')) {
  customElements.define('fan-collection', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 900px)');
      this.disclosure = this.querySelector('[data-filter-disclosure]');
      this.updateDisclosure = () => {
        if (this.disclosure) this.disclosure.open = !this.media.matches;
      };
      this.updateDisclosure();
      this.media.addEventListener('change', this.updateDisclosure);
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.updateDisclosure);
    }
  });
}
